import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, Input, input } from '@angular/core';
import { cn, IconPaletteType, IconType, SizeType } from '@cf/core';
import { CfIconDirective, CfIconNames, IconComponent, IconSizeType } from '@cf/shared/ui/icons';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cf-dropdown-item',
  template: `
    <button
      type="button"
      ngbDropdownItem
      class="dropdown-button"
      [ngClass]="{ 'tw:bg-blue-5': selected }"
    >
      <cf-icon
        *ngIf="icon"
        [icon]="icon"
        [color]="iconColor"
        [size]="iconSize"
        class="dropdown-icon"
      >
      </cf-icon>

      <svg *ngIf="cfIcon" [cfIcon]="cfIcon" [class]="iconClasses()" [size]="cfIconSize"></svg>

      <span class="dropdown-label" [ngClass]="{ 'tw:font-semibold!': selected }">
        <ng-content></ng-content>
      </span>
    </button>
  `,
  styleUrls: ['./dropdown-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdownButtonItem, NgbDropdownItem, NgClass, NgIf, IconComponent, CfIconDirective],
})
export class DropdownItemComponent {
  @Input() icon!: IconType;
  @Input() cfIcon!: CfIconNames;
  @Input() cfIconSize?: IconSizeType = 'sm';
  @Input() selected = false;

  @Input() iconColor: IconPaletteType = 'grey-70';
  readonly cfIconColor = input<string>();

  iconClasses = computed(() => cn('dropdown-icon', this.cfIconColor()));

  @Input() iconSize: SizeType = 'sm';
}
